// extracted by mini-css-extract-plugin
export default {"root":"InitiatedDummy_root__TndTd","title":"InitiatedDummy_title__zC1wX","description":"InitiatedDummy_description__nDeR4"};